module.exports = __webpack_public_path__ + "static/media/VIAGGI.df9e8fa3.svg";